import React from "react";
import Navbar from "./Navbar.js";
import SalesNavbar from "./SalesNavbar.js";
import { isCustomerProfile } from "./CustomComponent.js";

// หน้าจัดการทรัพย์ / ข้อมูลทรัพย์ / แดชบอร์ดขาย / นัดหมาย ใช้ร่วมกัน 2 ฝั่ง
//   นิติบุคคล + ผู้ดูแล -> เมนูฝั่งงานขาย (SalesNavbar) มี Console / แดชบอร์ดขาย / นัดหมาย
//   ลูกค้า            -> เมนูของลูกค้าเอง (Navbar) เพราะไม่มีสิทธิ์เมนูฝั่งงานขาย
//                        และต้องกลับไปหน้าค้างชำระ/ประวัติการชำระของตัวเองได้
//
// ★ อ่าน localStorage ตอน render ไม่ใช่ตอน import — ไฟล์นี้ถูก import ตั้งแต่หน้า login
//   ซึ่งยังไม่มีโปรไฟล์
// ★ ใช้ isCustomerProfile ไม่ใช่ user_type ตรง ๆ เพราะโปรไฟล์ที่ค้างจากเวอร์ชันเก่า
//   ไม่มี user_type จะถูกมองเป็นฝ่ายขายแล้วเมนูลูกบ้านหายทั้งแถบ
const PropertyNavbar = (props) => {
  return isCustomerProfile() ? <Navbar {...props} /> : <SalesNavbar {...props} />;
};

export default PropertyNavbar;
